var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ]
    },
    [
      _c(
        "div",
        { staticStyle: { "max-height": "4px" } },
        [
          _c("v-progress-linear", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cargando,
                expression: "cargando"
              }
            ],
            attrs: { indeterminate: "", color: "primary" }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mx-3" },
        [
          _c("v-text-field", {
            attrs: {
              name: "busqueda",
              "append-icon": "search",
              label: "Búsqueda.",
              "single-line": "",
              "hide-details": ""
            },
            on: { input: _vm.onFilterTextBoxChanged },
            model: {
              value: _vm.search,
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          }),
          _c(
            "v-layout",
            [
              _c("v-checkbox", {
                attrs: { label: "Solos Sin Transportista" },
                on: {
                  change: function($event) {
                    return _vm.handleCheckBox()
                  }
                },
                model: {
                  value: _vm.filtroNoAsignados,
                  callback: function($$v) {
                    _vm.filtroNoAsignados = $$v
                  },
                  expression: "filtroNoAsignados"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c("ag-grid-vue", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.cargando,
            expression: "!cargando"
          }
        ],
        staticClass: "ag-theme-material",
        staticStyle: { width: "auto", height: "200px" },
        attrs: {
          columnDefs: _vm.columnDefs,
          rowData: _vm.rowData,
          rowSelection: "multiple"
        },
        on: { "row-selected": _vm.onRowSelected, "grid-ready": _vm.onGridReady }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }